export enum AdCategory {
    FILM = 'film',
    EXTERNAL = 'external'
}
